import {BUDGET_TYPE, HIDDEN_FEATURES, MODULE_TYPES} from '../../../../constants';
import {isFeatureHidden} from '../../../shared/util/CompanySetupUtil';
import {hasSomePermission} from '../../../shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../../Permissions';
import {hasModule} from '../../../shared/util/ModuleUtil';
import {isCustomerPortalAvailable} from '../../../shared/util/customerPortalAvailability';

export const TABS = {
	GENERAL: {
		key: 'GENERAL',
		translationId: 'settings.general',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	STATUS: {
		key: 'STATUS',
		translationId: 'common.status',
		inConnectedProjectParent: false,
		financialsInfo: false,
	},
	PROJECT_PROGRESS: {
		key: 'PROJECT_PROGRESS',
		translationId: 'common.progress',
		inConnectedProjectParent: false,
		financialsInfo: false,
		isVisible: project => {
			return (
				(isFeatureHidden(HIDDEN_FEATURES.TIME_REGISTRATIONS) && !hasModule(MODULE_TYPES.SAGE_PSA_RESTRICTED)) ||
				BUDGET_TYPE.NON_BILLABLE === project.budgetType
			);
		},
	},
	TASKS: {
		key: 'TASKS',
		translationId: 'common.tasks',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	FINANCIALS: {
		key: 'FINANCIALS',
		translationId: 'common.financials',
		inConnectedProjectParent: false,
		financialsInfo: true,
		isVisible: () => {
			return hasSomePermission([
				PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION,
				PERMISSION_TYPE.VIEW_FINANCIAL_INFORMATION_REVENUE,
			]);
		},
	},
	TEAM: {
		key: 'TEAM',
		translationId: 'common.team',
		inConnectedProjectParent: true,
		financialsInfo: false,
	},
	INTEGRATIONS: {
		key: 'INTEGRATIONS',
		translationId: 'settings_account.section-integrations',
		inConnectedProjectParent: false,
		financialsInfo: false,
	},
	// FOR-48 (BU-10) 10b — Client Portal tab. Availability-gated (module/flag).
	// Only the "Show in client portal" toggle + phase-status visibility live here;
	// branding/flags/activation are Client Organisation level (10a), never here.
	CLIENT_PORTAL: {
		key: 'CLIENT_PORTAL',
		translationId: 'client_portal.section_title',
		inConnectedProjectParent: false,
		financialsInfo: false,
		isVisible: () => isCustomerPortalAvailable(),
	},
};
